import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export enum NFS_EXPORT_ACCESS_TYPE {
  READ = 'ro',
  READ_WRITE = 'rw'
}

type NfsExportAccessTypeText = Record<NFS_EXPORT_ACCESS_TYPE, string>

export const NFS_EXPORT_ACCESS_TYPE_TEXT = computedLocale<NfsExportAccessTypeText>(() => ({
  [NFS_EXPORT_ACCESS_TYPE.READ]: i18n.t('Read'),
  [NFS_EXPORT_ACCESS_TYPE.READ_WRITE]: i18n.t('Read and write')
}));

export enum NFS_EXPORT_SQUASH {
  ROOT_SQUASH = 'root_squash',
  ROOT_ID_SQUASH = 'root_id_squash',
  ALL_SQUASH = 'all_squash',
  NONE = 'none'
}

type NfsExportSquashSelectText = Record<NFS_EXPORT_SQUASH, string>

export const NFS_EXPORT_SQUASH_SELECT_TEXT = computedLocale<NfsExportSquashSelectText>(() => ({
  [NFS_EXPORT_SQUASH.ROOT_SQUASH]: i18n.t('Disallow access with root UID'),
  [NFS_EXPORT_SQUASH.ROOT_ID_SQUASH]: i18n.t('Disallow access with root UID but allow access to user groups with non-zero GIDs'),
  [NFS_EXPORT_SQUASH.ALL_SQUASH]: i18n.t('Squash all users to anonymous'),
  [NFS_EXPORT_SQUASH.NONE]: i18n.t('Allow access with root UID')
}));
